// extracted by mini-css-extract-plugin
export var dropdown = "_ng-1";
export var hidden = "_ng-0";